<div class="analytics-main">
  <div class="api-flex-container">
    <p class="page-title">Analytics Settings</p>
    <br/>
    @if (trial | async; as title) {
      <p class="page-description"> {{title['title']}}
        <a target="_blank" class="read-more" [href]="title['linkUrl']">{{title['linkText']}}</a>.</p>
      }
      <div class="full-width">
        <div class="pull-left">
          <button class="create-collection-button" (click)="openPopup()">
            <span class="cross"></span> Add Collection
          </button>
        </div>
        <div class="pull-right move-right">
          <input
            class="searchBtn"
            placeholder="Search Collection"
            value=""
            type="text"
            [(ngModel)]="searchCollectionsValue">
            <button class="filter-button"
              (click)="onFilterButtonClick()"
              [ngClass]="showFilter ? 'click' : ''">
              <img class="flow-img" src='../../../../../../assets/svg/filter-only.svg' alt="flow.svg">
            </button>
          </div>
        </div>
      </div>
      @if (showFilter) {
        <div class="filter-wrapper">
          <div class="filter-options">
            <ul>
              @for (filter of collectionFilters; track filter) {
                <li class="menu_item">
                  <mat-checkbox
                    class="test"
                    [(ngModel)]="filter.selected"
                    (change)="onFilterChange($event, filter.name)">
                    <span class="menu_item_label" [class]="filter.styleClass">{{filter.label}}</span>
                  </mat-checkbox>
                </li>
              }
            </ul>
          </div>
          <div class="bottom-bar">
            <div class="primary">
              <div class="btn cancel-btn" (click)="onFilterCancel()">
                Cancel
              </div>
              <div class="btn save-btn"
                [ngClass]="isApplyFilter ?  'save-btn-enabled ' : 'save-btn-disabled'"
                (click)="onFilterApply()">
                Apply
              </div>
            </div>
          </div>
        </div>
      }
      <div class="clear"></div>
      <div class="collection-table-container">
        <div class="collection-table-block">
          <app-collections-table
            [searchCollection]="searchCollectionsValue"
            [canEditCollections]="canEditCollections"
            [canSelect]="canSelectCollections"
            [collectionCurrentStatus]="collectionStatus"
            [filters]="selectedFilters"
          ></app-collections-table>
        </div>
      </div>
    </div>
